export default class AccountGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  onAddSuccess(accountDto) {}

  onAddError(error) {}
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/channels/account_gateway_observer.js